import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Translation } from 'react-i18next';
import { isEmpty } from 'lodash';
import {
  checkUser,
  setModalImage,
  updateUserProgress,
  getUserData,
  getCareerBasicsForTenant,
} from '../../../store/actions';
import CompareCareers from './careers/CompareCareers';
import CompareDegrees from './degrees/CompareDegrees';
import Scrollbar, { SCROLLBAR_WIDTH_PX } from '../../Scrollbar';
import TopModal from './TopModal';
import { fireGTM } from '../../../gtm/gtmUtil';
import { getCategoryImages } from '../getCategoryImages';
import { getOnboardingState, getAuthState } from '../../../store/selectors';
import { getTop3Path } from '../../../util/paths';
import { ModalityIcons } from '../ToggleButtonModality';
import { modalPage_GTM } from '../../../gtm/datalayers/modalsDataLayers.json';
import { ModalCompare } from './ModalCompare';
import Loading from '../Loading';

/* eslint-disable react/jsx-props-no-spreading */

class Modal extends PureComponent {
  constructor(props) {
    super(props);
    this.modal = React.createRef();
    this.handleClickOutsideModal = this.handleClickOutsideModal.bind(this);
    this.state = {
      compareCareers: false,
      compareDegrees: false,
      allCareers: [],
      allDegreesForCareer: [],
      image: null,
      /* we are actually just using the following state to update the component :/ */
      /* eslint-disable react/no-unused-state */
      careerInfoLoading: true,
    };
  }

  getAllDegreesForCareerChoice(careerChoiceIdsArray) {
    let degreesForCareer = [];

    careerChoiceIdsArray.forEach((careerChoiceId) => {
      this.props.onboarding.userData.degreeCareerIdMap[careerChoiceId].forEach(
        (degreeCareerId) => {
          if (degreeCareerId.id === this.props.degree.id) {
            degreesForCareer = [
              ...degreesForCareer,
              ...this.props.onboarding.userData.degreeCareerIdMap[
                careerChoiceId
              ],
            ];
          }
        }
      );
    });
    // Remove the current Modal'd degree from the list of comparison degrees
    degreesForCareer.splice(
      degreesForCareer.findIndex((item) => item.id === this.props.degree.id),
      1
    );

    return degreesForCareer;
  }

  async componentDidMount() {
    if (!this.props.onboarding.userData.userProgress) {
      this.props.getUserData(
        this.props.onboarding.userData.user.id,
        this.props.auth.jwtToken
      );
    }
    if (this.props.location.state) {
      if (this.props.location.state.fromCareerSearch) {
        await this.props.updateUserProgress(this.props.auth.jwtToken, {
          searched_career: true,
        });
      }
    }
    if (
      !!this.props.degree &&
      !this.props.onboarding.userData.userProgress?.viewed_degree_details
    ) {
      await this.props.updateUserProgress(this.props.auth.jwtToken, {
        viewed_degree_details: true,
      });
    }
    document.addEventListener('mousedown', this.handleClickOutsideModal);

    const modalImage = this.props.career
      ? this.randomAvailableCareerImage(this.props.career)
      : this.props.degree?.categoryImageUrl1;

    if (!this.props.onboarding.modalImage) this.props.setModalImage(modalImage);
    this.setImage();

    let allDegreesForCareerChoice = [];

    // Get all the degrees for the career this degree Modal is related to
    if (this.props.degree) {
      const careerChoicesIds = Object.values(
        this.props.onboarding.careerChoices
      ).map((career) => {
        return career.id;
      });

      allDegreesForCareerChoice =
        this.getAllDegreesForCareerChoice(careerChoicesIds);
    }

    this.setState({
      allDegreesForCareer: allDegreesForCareerChoice,
    });
  }

  componentWillUnmount() {
    window.removeEventListener('mousedown', this.handleClickOutsideModal);
  }

  handleClickOutsideModal = (event) => {
    if (!(this.modal && this.modal.current)) return;

    const targetElement = event.target;
    const parentElement = event.target.parentElement;

    if (
      (targetElement?.getAttribute('class') || '').includes(
        'root-content-scroll-y'
      ) ||
      (parentElement?.getAttribute('class') || '').includes(
        'root-content-scroll-y'
      )
    ) {
      return;
    }

    if (
      !this.modal.current.contains(event.target) &&
      !event.target.closest('.modal-parent')
    ) {
      this.props.setModalImage(null);
      this.props.closeModal(
        null,
        this.props.userProfileId,
        this.props.userProfileTenantId
      );
    }
  };

  careerInfoLoading = () => {
    this.setState({
      careerInfoLoading: false,
    });
  };

  // Show the compare careers search element
  showCompareCareersSearchBar = () => {
    this.setState((prevState) => ({
      compareCareers: !prevState.compareCareers,
    }));
  };

  // Show the compare degrees search element
  showCompareDegreesSearchBar = () => {
    this.setState((prevState) => ({
      compareDegrees: !prevState.compareDegrees,
    }));
  };

  displayList(tasks) {
    // we don't have the list info in our db yet
    const taskList = Object.values(tasks).map((task) => (
      <div className="career-bullets" data-cy="career-bullets" key={task}>
        <span className="yellow-dots">
          <svg height="10" width="10" role="img">
            <title>Bullet Point</title>
            <circle cx="5" cy="5" r="4" fill="#FFC626" />
          </svg>
        </span>
        <p className="bullet-item">{task}</p>
      </div>
    ));

    return (
      <div
        className="career-bullets-container"
        data-cy="career-bullets-container"
      >
        {taskList}
      </div>
    );
  }

  handleLocationClickedGTM = (location) => {
    modalPage_GTM.availableLocationLink.text = location.institution_name;
    fireGTM(modalPage_GTM.availableLocationLink);
  };

  listAvailableLocations(locations) {
    console.log({tenantName:this.props.tenant.name})
    const newLocations = this.props.tenant.name.toLowerCase() === 'pitt' ? locations.institution_info : locations
    return newLocations.map((location) => {
      const anchorText = this.props.tenant.name.toLowerCase() === 'pitt' ? locations.titleEn : location.institution_name
      return (
        <a
          href={`${location.url}`}
          target="_blank"
          rel="noopener noreferrer"
          key={`${location.url}`}
          onClick={() => this.handleLocationClickedGTM(location)}
        >
          <p className="available-location" style={this.primaryColor}>
            {anchorText}
          </p>
        </a>
      )
    }
    );
  }

  checkDegreeIcons = (degree) => {
    if (!degree) return null;

    return (
      <>
        <ModalityIcons className="icon" degree={degree} />
        <p data-cy="modal-degree-type-en">{degree.degreeTypeEn}</p>
      </>
    );
  };

  handleAddCareer = async (career) => {
    this.props.setModalImage(null);
    this.props.history.push(
      getTop3Path(this.props.tenant, this.props.location, career.id)
    );
  };

  handleAddDegree = async (degree) => {
    this.props.setModalImage(null);
    this.props.history.push(
      getTop3Path(this.props.tenant, this.props.location, degree.titleEn)
    );
  };

  isTopCareer = (careerId) => {
    const careerOption = Object.values(
      this.props.onboarding.userData.careerGameResults
    ).find((match) => match.id === careerId);

    if (
      !careerOption ||
      (careerOption?.chosenOrder === null &&
        !this.props.location.pathname.includes('career-path/top-3'))
    ) {
      return false;
    }

    return true;
  };

  modalItem = () => {
    if (!isEmpty(this.props.degree)) return this.props.degree;
    if (!isEmpty(this.props.career)) return this.props.career;
    if (!isEmpty(this.props.careerToCompare)) return this.props.careerToCompare;
    if (!isEmpty(this.props.degreeToCompare)) return this.props.degreeToCompare;

    return null;
  };

  randomAvailableCareerImage = (career) => {
    const list = [];

    if (career?.categoryImageUrl1) list.push(career?.categoryImageUrl1);
    if (career?.categoryImageUrl2) list.push(career?.categoryImageUrl2);
    if (career?.categoryImageUrl3) list.push(career?.categoryImageUrl3);
    if (career?.categoryImageVariant) list.push(career?.categoryImageVariant);

    const max = list.length - 1;
    const min = 0;
    const random = Math.round(Math.random() * (max - min) + min);

    return list[random];
  };

  setImage = () => {
    if (this.props.degree) {
      this.setState({
        image: this.props.degree?.categoryImageUrl2
          ? this.props.degree?.categoryImageUrl2
          : this.props.degree?.categoryImageUrl1,
      });
    }

    if (this.props.career) {
      const careerImage = this.randomAvailableCareerImage(this.props.career);

      this.setState({
        image:
          this.props.onboarding.modalImage && !this.props.second
            ? this.props.onboarding.modalImage
            : careerImage,
      });
    }
  };

  checkCompareSections = () => {
    if (this.state.compareCareers) {
      return (
        <CompareCareers
          careerList={this.state.allCareers}
          getCareerList={this.props.getCareerBasicsForTenant}
          color={this.props.tenant.primary}
          showCompareCareersSearchBar={this.showCompareCareersSearchBar}
          favorites={
            this.props.location.pathname.includes('user-profile')
              ? null
              : this.props.onboarding.favorites
          }
          careerGameResults={
            this.props.location.pathname.includes('user-profile')
              ? null
              : this.props.onboarding.userData.careerGameResults
          }
        />
      );
    }

    if (this.state.compareDegrees) {
      return (
        <CompareDegrees
          degreeList={this.state.allDegreesForCareer}
          color={this.props.tenant.primary}
          showCompareDegreesSearchBar={this.showCompareDegreesSearchBar}
        />
      );
    }
  };

  getModalBlackBoxCopy = (t) => {
    let blackBox;

    if (this.props.degree) {
      blackBox = this.props.degree.academicProgramType;
    }

    if (this.props.career) {
      blackBox = t('Career');
    }

    return blackBox;
  };

  render() {
    const ContentWrapper = Scrollbar;
    const contentWrapperProps = {};
    contentWrapperProps.className = 'career-content-scrollable';
    contentWrapperProps.style = { marginRight: `${SCROLLBAR_WIDTH_PX}px` };
    const title = this.props.degree
      ? this.props.degree.titleEn
      : this.props.career.titleEn;
    const description = this.props.degree
      ? this.props.degree.descriptionEn
      : this.props.career.description;
    const requirements = this.props.degree
      ? this.props.degree.requirements
      : null;
    const transferable = this.props.degree
      ? this.props.degree.transferable
      : null;
    const modalItem = this.modalItem();

    return (
      <Translation>
        {(t) => (
          <>
            <div
              id={
                this.props.modalClassName.includes('modal1')
                  ? 'modal1'
                  : 'modal2'
              }
              data-cy="modal"
              className={['modal-parent', this.props.modalClassName].join(' ')}
              ref={this.modal}
            >
              {this.props.loading ? (
                <Loading height="100%" />
              ) : (
                <>
                  {this.props.children}
                  <TopModal
                    modalItem={modalItem}
                    userProfileId={this.props.userProfileId}
                    userProfileTenantId={this.props.userProfileTenantId}
                    closeModal={this.props.closeModal}
                    focusX={this.props.focusX}
                    blackBox={this.getModalBlackBoxCopy(t)}
                    img={this.state.image}
                    degree={this.props.degree}
                    tenant={this.props.tenant}
                    showCompareCareersSearchBar={
                      this.showCompareCareersSearchBar
                    }
                    showCompareDegreesSearchBar={
                      this.showCompareDegreesSearchBar
                    }
                    careerToCompare={this.props.careerToCompare}
                    degreeToCompare={this.props.degreeToCompare}
                    originalCareer={this.props.career}
                    favorites={this.props.onboarding.favorites}
                    showDegreeComparisonDropdown={
                      this.state.allDegreesForCareer.length > 1
                    }
                    location={this.props.location}
                  />
                  {/* eslint-disable-next-line react/jsx-one-expression-per-line */}
                  {this.checkCompareSections()}
                  <ContentWrapper {...contentWrapperProps}>
                    <ModalCompare
                      degree={this.props.degree}
                      career={this.props.career}
                      modalClassName={this.props.modalClassName}
                      title={title}
                      isTopCareer={this.isTopCareer}
                      transferable={transferable}
                      checkDegreeIcons={this.checkDegreeIcons}
                      description={description}
                      requirements={requirements}
                      handleAddCareer={this.handleAddCareer}
                      careerInfoLoading={this.careerInfoLoading}
                      degreeInformation={this.state.degreeInformation}
                      displayList={this.displayList}
                      listAvailableLocations={(location) =>
                        this.listAvailableLocations(location)
                      }
                      modalNumber={
                        this.props.modalClassName.includes('modal1') ? '1' : '2'
                      }
                      location={this.props.location}
                    />
                  </ContentWrapper>
                </>
              )}
            </div>
          </>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = (state) => {
  const onboarding = getOnboardingState(state);
  const auth = getAuthState(state);
  const userProfileId = state.admin.userProfileInfo.id;
  const userProfileTenantId = state.admin.userProfileInfo.tenantId;

  return {
    onboarding,
    auth,
    userProfileId,
    userProfileTenantId,
  };
};

export default withRouter(
  connect(mapStateToProps, {
    checkUser,
    setModalImage,
    updateUserProgress,
    getUserData,
    getCareerBasicsForTenant,
  })(Modal)
);
